import React from "react";
import { Save } from 'react-feather';

import './index.scss'

const SaveButton = ({
  onClick,
  title
}) => {
  
  return (
    <>
      {
        <div className="Save-button__Save" onClick={onClick}><Save />{title}</div>
      }
    </>
  )
}

export default SaveButton
